import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon-circle-info-solid" }, null, -1);
import { ref, onMounted } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Tooltip',
    props: {
        text: {}
    },
    setup(__props) {
        const props = __props;
        const isActive = ref(false);
        const tooltip = ref(null);
        onMounted(() => {
            document.addEventListener('click', (event) => {
                if (tooltip.value && event.target !== tooltip.value) {
                    isActive.value = false;
                }
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "tooltip",
                ref_key: "tooltip",
                ref: tooltip,
                onClick: _cache[0] || (_cache[0] = ($event) => (isActive.value = !isActive.value))
            }, [
                _hoisted_1,
                _createElementVNode("span", {
                    class: _normalizeClass(["tooltip-text", { 'is--active': isActive.value }])
                }, _toDisplayString(props.text), 3)
            ], 512));
        };
    }
});
